export const getAgentStatus = (answerState: string): string => {
  switch (answerState) {
    case "answered":
      return "On Call";
    case "ringing":
      return "Ringing";
    default:
      return "Available";
  }
};